import { TUserNotificationType } from "@/types/app";
import { BellIcon, MessageSquareIcon } from "lucide-react";
import Link from "next/link";
import ProfilePicture from "../../profile-picture";

type TNotificationCardProps = {
	title: string | null;
	description?: string | null;
	image?: string | null;
	notificationType: TUserNotificationType;
	isVerified?: boolean | null;
	isFounder?: boolean | null;
	link: string | null;
	time: string;
};

const NotificationCard = ({
	title,
	description,
	image,
	notificationType,
	isVerified,
	isFounder,
	link,
	time,
}: TNotificationCardProps) => {
	return (
		<div className="rounded-lg bg-gray-50 px-4 py-2">
			<div className="group flex items-center justify-start gap-2">
				<div>
					{image ? (
						<ProfilePicture
							profilePictureUrl={image}
							alternateText={title || "Notification"}
							className={{
								container: "h-10 w-10 rounded-full p-0.5",
								image: "rounded-full text-gray-600",
								badgeImage: "-bottom-4 h-8 w-8",
							}}
							isVerified={isVerified}
							isFounder={isFounder}
						/>
					) : notificationType === "NEW_DISCUSSION_POST" ? (
						<div className="flex h-6 w-6 items-center justify-center rounded-full bg-gray-200 text-sm font-medium text-gray-600 transition-colors duration-100 ease-linear group-hover:bg-brand-primary group-hover:text-white">
							{title?.[0]}
						</div>
					) : notificationType === "COMMENT" ? (
						<MessageSquareIcon className="h-4 w-4 fill-gray-300 stroke-gray-300" />
					) : (
						<BellIcon className="h-4 w-4 fill-gray-300 stroke-gray-300" />
					)}
				</div>

				<div className="basis-full space-y-1">
					{link ? (
						<Link
							href={link}
							className="line-clamp-4 block w-full py-2 text-xs font-medium leading-tight text-gray-600 first-letter:uppercase group-hover:text-brand-primary"
						>
							{title}
						</Link>
					) : (
						<h5 className="line-clamp-4 w-full py-2 text-xs font-medium leading-tight text-gray-600 first-letter:uppercase">
							{title}
						</h5>
					)}

					{description && <p className="text-xxs text-gray-500">{description}</p>}

					<p className="text-xxs text-gray-500">{time}</p>
				</div>
			</div>
		</div>
	);
};

export default NotificationCard;
